import React, { Component } from 'react';
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import { Link } from "react-router-dom";
import { AppContext } from '../../AppContext'
import ApiSso from '../../actions/sso';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css'
import auth from '../../actions/auth';
import qs from 'qs';
import Api from "../../actions/api";


class LoginMember extends Component {

    static contextType = AppContext;

    constructor(props){
        super(props);
        this.state = {
            isLoading: false,
            step: 2,
            status: false,
            read: false,
            validated: {}
        }

        this.handleLogin = this.handleLogin.bind(this);
    }

    componentDidMount(){
        this.setState({isLoading: true});

        let token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true}).token;
        let plan = qs.parse(this.props.location.search, {ignoreQueryPrefix: true}).plan;

        this.handleLogin(token, plan);
    }

    auth() {
        const client = process.env.REACT_APP_CLIENT;
        const key = process.env.REACT_APP_KEY;

        return ApiSso.post('client', {
            'client': client,
            'key': key
        });
    }

    handleLogin(token, plan) {
        this.setState({isLoading: true});
        const { setUserLogged, setUserStep } = this.context;

        this.auth().then(authResponse  => {
            ApiSso.defaults.headers.common['Authorization'] = authResponse.data.data.token;
            ApiSso.post('user/sign_in/token', {
                'token': token
            }).then((response) => {
                localStorage.setItem('user_plan_id', plan)
                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('name', response.data.data.people.first_name);
                localStorage.setItem('last_name', response.data.data.people.last_name);
                localStorage.setItem('email', response.data.data.email);
                localStorage.setItem('user_email', response.data.data.email);
                localStorage.setItem('account', response.data.data.account);
                localStorage.setItem('user', response.data.data.user);
                localStorage.setItem('document_type', response.data.data.document_type);
                localStorage.setItem('photo', response.data.data.photo);
                localStorage.setItem('isLogged', "true");

                setUserLogged(true)


                Api.defaults.headers.common['Authorization'] = authResponse.data.data.token;
                Api.get('/account/' + response.data.data.account + '/purchased_pack/check', {})
                    .then((response) => {
                        if (response.data.has_purchased_pack) {
                            this.props.history.push("/dashboard");
                            window.location.reload();
                        } else {
                            this.props.history.push("/payment/one-click");
                            window.location.reload();
                        }
                    }).catch((error) => {
                        this.setState({isLoading: false});

                        toastr.options = {
                            positionClass : 'toast-top-full-width',
                            hideDuration: 300,
                            timeOut: 60000
                        }
                        toastr.clear()
                        setTimeout(() => toastr.error('Ocorreu um problema, tenta novamente.'), 300)

                        this.props.history.push("/login");
                        window.location.reload();
                    });
                this.setState({isLoading: false});

            }).catch((error) => {

                this.setState({isLoading: false});

                toastr.options = {
                    positionClass : 'toast-top-full-width',
                    hideDuration: 300,
                    timeOut: 60000
                }
                toastr.clear()
                setTimeout(() => toastr.error('Senha inválida, tente novamente.'), 300)

                this.props.history.push("/login");
                window.location.reload();

            });
        })
    }

    render(){
        return(
            <div>
                {this.state.isLoading ? (
                    <LoadingComponent />
                ) : ( <></> )}

            </div>
        )
    }
}

export default LoginMember